var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "div",
        { attrs: { id: "tab-mbl" } },
        [
          _c("div", { staticClass: "section operations" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.cooperateEdit,
                    expression: "cooperateEdit"
                  }
                ],
                staticClass: "triggers"
              },
              [
                _c(
                  "div",
                  [
                    _c(
                      "el-dropdown",
                      {
                        class: _vm.readonly ? "not-click" : "",
                        attrs: { no: "1", "split-button": "", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.commandHandle(_vm.command1)
                          },
                          command: function(p) {
                            _vm.command1 = p
                            _vm.commandHandle(_vm.command1)
                          }
                        }
                      },
                      [
                        _vm._v(" " + _vm._s(_vm.command1) + " "),
                        _c(
                          "el-dropdown-menu",
                          { attrs: { slot: "dropdown" }, slot: "dropdown" },
                          [
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  command: _vm.$t("SeaExport.CodeSearching")
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.CodeSearching"))
                                )
                              ]
                            ),
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  command: _vm.$t(
                                    "SeaExport.CopyFromTheLastTime"
                                  )
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("SeaExport.CopyFromTheLastTime")
                                  )
                                )
                              ]
                            ),
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  command: _vm.$t("SeaExport.CopyFromOtherBill")
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.CopyFromOtherBill"))
                                )
                              ]
                            ),
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  command: _vm.$t("SeaExport.CopyFromHbl")
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.CopyFromHbl")))]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-button",
                      {
                        staticStyle: { "margin-right": "5px" },
                        attrs: {
                          no: "2",
                          disabled: _vm.feedBtnDisabled,
                          type: "primary"
                        },
                        on: {
                          click: function($event) {
                            return _vm.pm.completefeedClickHandler()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.CompleteTheDetails")))]
                    ),
                    _c(
                      "el-dropdown",
                      {
                        class: _vm.btnBLConfirmDisabled ? "not-click" : "",
                        attrs: { no: "3", "split-button": "", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.commandHandle(_vm.command2)
                          },
                          command: function(p) {
                            _vm.command2 = p
                            _vm.commandHandle(_vm.command2)
                          }
                        }
                      },
                      [
                        _vm._v(" " + _vm._s(_vm.command2) + " "),
                        _c(
                          "el-dropdown-menu",
                          { attrs: { slot: "dropdown" }, slot: "dropdown" },
                          [
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  command: _vm.$t("SeaExport.ReceiptHistory")
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.ReceiptHistory"))
                                )
                              ]
                            ),
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  command: _vm.$t(
                                    "SeaExport.BillingOfLadingRecordManager"
                                  )
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "SeaExport.BillingOfLadingRecordManager"
                                    )
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm.viewSource === "SiBooking"
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: ["button_insurance_toInsure"],
                                expression: "['button_insurance_toInsure']"
                              }
                            ],
                            attrs: {
                              no: "4",
                              disabled: _vm.isEdit,
                              type: "primary"
                            },
                            on: {
                              click: function($event) {
                                return _vm.pm.toInsure()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Insure")))]
                        )
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.btnMergeHblDataVisible,
                            expression: "btnMergeHblDataVisible"
                          }
                        ],
                        attrs: {
                          no: "5",
                          disabled: _vm.readonly,
                          type: "primary"
                        },
                        on: {
                          click: function($event) {
                            return _vm.pm.mergeHblData()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.mergeHblData")))]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        staticStyle: { "margin-left": "10px" },
                        attrs: {
                          no: "6",
                          value: _vm.form.state >= 2,
                          disabled: true
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.Printed")))]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        staticStyle: { "margin-left": "-20px" },
                        attrs: {
                          no: "7",
                          value: _vm.form.state === 3,
                          disabled: true
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("Message.Locked")))]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        staticStyle: { "margin-left": "-20px" },
                        attrs: { no: "8", disabled: _vm.readonly },
                        model: {
                          value: _vm.form.oversea,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "oversea", $$v)
                          },
                          expression: "form.oversea"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.BlBeReleased")))]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        staticStyle: { "margin-left": "-20px" },
                        attrs: { no: "9", disabled: _vm.readonly },
                        on: {
                          change: function($event) {
                            return _vm.pm.eDIChange($event)
                          }
                        },
                        model: {
                          value: _vm.form.edi,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "edi", $$v)
                          },
                          expression: "form.edi"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.BlEdi")))]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        staticStyle: { "margin-left": "-20px" },
                        attrs: { no: "10", disabled: _vm.readonly },
                        model: {
                          value: _vm.form.manifestEDI,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "manifestEDI", $$v)
                          },
                          expression: "form.manifestEDI"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.ManifestEdi")))]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        staticStyle: { "margin-left": "-20px" },
                        attrs: { no: "11", disabled: _vm.readonly },
                        model: {
                          value: _vm.form.printParam1,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "printParam1", $$v)
                          },
                          expression: "form.printParam1"
                        }
                      },
                      [_vm._v("Part of")]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        staticStyle: { "margin-left": "-20px" },
                        attrs: { no: "12", disabled: _vm.readonly },
                        model: {
                          value: _vm.form.printParam3,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "printParam3", $$v)
                          },
                          expression: "form.printParam3"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "SeaExport.ShowNumberOfPackagesGrossWeightAndMeasurementAfterCNTRNOSSEALNOS"
                            )
                          )
                        )
                      ]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.job.barge,
                            expression: "job.barge"
                          }
                        ],
                        staticStyle: { "margin-left": "-20px" },
                        attrs: { no: "13", disabled: _vm.readonly },
                        on: {
                          change: function($event) {
                            return _vm.pm.printParam6Change()
                          }
                        },
                        model: {
                          value: _vm.form.printParam6,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "printParam6", $$v)
                          },
                          expression: "form.printParam6"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("SeaExport.PrintBargeVesselAndVoyage"))
                        )
                      ]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        staticStyle: { "margin-left": "-20px" },
                        attrs: { no: "14", disabled: _vm.readonly },
                        model: {
                          value: _vm.form.showPODAgency,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "showPODAgency", $$v)
                          },
                          expression: "form.showPODAgency"
                        }
                      },
                      [_vm._v("Show POD Agency")]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.btnExcelVisible,
                            expression: "btnExcelVisible"
                          }
                        ],
                        attrs: { no: "15", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.pm.exportToExcel()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("Payment.exportExcel")))]
                    )
                  ],
                  1
                )
              ]
            )
          ]),
          _c("div", { staticStyle: { display: "flex" } }, [
            _c(
              "div",
              { staticClass: "down-first section form-column" },
              [
                _c(
                  "el-form",
                  {
                    staticStyle: { height: "100%" },
                    attrs: {
                      "label-width": _vm.isZh ? "70px" : "75px",
                      "label-position": "right"
                    }
                  },
                  [
                    _c("span", { staticClass: "title" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("SeaExport.ConsigneeShipperAndNotifyInfo")
                        )
                      )
                    ]),
                    _c(
                      "el-form-item",
                      { staticClass: "auto-width" },
                      [
                        _c(
                          "template",
                          { slot: "label" },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("Message.Shipper")))
                            ]),
                            _c("char-count", {
                              staticStyle: {
                                position: "static",
                                display: "block",
                                "font-size": "10px",
                                color: "#909399"
                              },
                              attrs: { form: _vm.form, prefix: "shipper" }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticStyle: { display: "flex", width: "100%" } },
                          [
                            _c("el-input", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                  expression:
                                    "!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                }
                              ],
                              attrs: { disabled: _vm.readonly, no: "16" },
                              model: {
                                value: _vm.form.shipperCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "shipperCode", $$v)
                                },
                                expression: "form.shipperCode"
                              }
                            }),
                            _c("cargo-advance-select", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                  expression:
                                    "synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                }
                              ],
                              attrs: {
                                no: "17",
                                disabled: _vm.readonly,
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Company,
                                "method-params": {
                                  partnerManagementMode:
                                    _vm.partnerManagementMode,
                                  branchId: _vm.$store.getters.currentOfficeId,
                                  shipper: true
                                },
                                filterable: "",
                                "default-value": _vm.form.shipperId || ""
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.senderAndReceiverChange("shipper", p, 7)
                                }
                              }
                            }),
                            _c(
                              "el-button",
                              {
                                staticStyle: { "margin-left": "5px" },
                                attrs: {
                                  no: "18",
                                  disabled: _vm.readonly,
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.clearSenderAndReceiver(
                                      "shipper",
                                      7
                                    )
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Reset")))]
                            )
                          ],
                          1
                        )
                      ],
                      2
                    ),
                    _vm._l(7, function(count) {
                      return _c(
                        "el-form-item",
                        {
                          key: "shipperLine" + count,
                          staticClass: "auto-width",
                          class: _vm.getSenderAndReceiverColor(
                            "shipperLine",
                            count
                          )
                        },
                        [
                          _c("cargo-input", {
                            ref: "shipperLine" + count,
                            refInFor: true,
                            attrs: {
                              disabled: _vm.readonly,
                              no: "shipperLine" + count,
                              "auto-uppercase":
                                _vm.notUppercaseShipperConsigneNotify,
                              "use-read-only": true
                            },
                            on: {
                              change: function() {
                                return _vm.wrapAddr(
                                  _vm.form,
                                  "shipperLine" + count,
                                  count + 1 > 7
                                    ? null
                                    : "shipperLine" + (count + 1),
                                  _vm.maxChars
                                )
                              }
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                return _vm.showSenderAndReceiverDialog(
                                  "shipper",
                                  7,
                                  _vm.isCarrierUserMSC,
                                  _vm.notUppercaseShipperConsigneNotify
                                )
                              }
                            },
                            model: {
                              value: _vm.form["shipperLine" + count],
                              callback: function($$v) {
                                _vm.$set(_vm.form, "shipperLine" + count, $$v)
                              },
                              expression: "form['shipperLine'+count]"
                            }
                          })
                        ],
                        1
                      )
                    }),
                    _c(
                      "el-form-item",
                      { staticClass: "auto-width" },
                      [
                        _c(
                          "template",
                          { slot: "label" },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("Message.Consignee")))
                            ]),
                            _c("char-count", {
                              staticStyle: {
                                position: "static",
                                display: "block",
                                "font-size": "10px",
                                color: "#909399"
                              },
                              attrs: { form: _vm.form, prefix: "consignee" }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticStyle: { display: "flex", width: "100%" } },
                          [
                            _c("el-input", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                  expression:
                                    "!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                }
                              ],
                              attrs: { disabled: _vm.readonly, no: "19" },
                              model: {
                                value: _vm.form.consigneeCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "consigneeCode", $$v)
                                },
                                expression: "form.consigneeCode"
                              }
                            }),
                            _c("cargo-advance-select", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                  expression:
                                    "synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                }
                              ],
                              attrs: {
                                no: "20",
                                disabled: _vm.readonly,
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Company,
                                "method-params": {
                                  partnerManagementMode:
                                    _vm.partnerManagementMode,
                                  branchId: _vm.$store.getters.currentOfficeId,
                                  consignee: true
                                },
                                filterable: "",
                                "default-value": _vm.form.consigneeId || ""
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.senderAndReceiverChange("consignee", p, 7)
                                }
                              }
                            }),
                            _c(
                              "el-button",
                              {
                                staticStyle: { "margin-left": "5px" },
                                attrs: {
                                  type: "primary",
                                  disabled: _vm.readonly
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.clearSenderAndReceiver(
                                      "consignee",
                                      7
                                    )
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Reset")))]
                            )
                          ],
                          1
                        )
                      ],
                      2
                    ),
                    _vm._l(7, function(count) {
                      return _c(
                        "el-form-item",
                        {
                          key: "consigneeLine" + count,
                          staticClass: "auto-width",
                          class: _vm.getSenderAndReceiverColor(
                            "consigneeLine",
                            count
                          )
                        },
                        [
                          _c("cargo-input", {
                            ref: "consigneeLine" + count,
                            refInFor: true,
                            attrs: {
                              disabled: _vm.readonly,
                              no: "consigneeLine" + count,
                              "auto-uppercase":
                                _vm.notUppercaseShipperConsigneNotify,
                              "use-read-only": true
                            },
                            on: {
                              change: function() {
                                return _vm.wrapAddr(
                                  _vm.form,
                                  "consigneeLine" + count,
                                  count + 1 > 7
                                    ? null
                                    : "consigneeLine" + (count + 1),
                                  _vm.maxChars
                                )
                              }
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                return _vm.showSenderAndReceiverDialog(
                                  "consignee",
                                  7,
                                  _vm.isCarrierUserMSC,
                                  _vm.notUppercaseShipperConsigneNotify
                                )
                              }
                            },
                            model: {
                              value: _vm.form["consigneeLine" + count],
                              callback: function($$v) {
                                _vm.$set(_vm.form, "consigneeLine" + count, $$v)
                              },
                              expression: "form['consigneeLine'+count]"
                            }
                          })
                        ],
                        1
                      )
                    }),
                    _c(
                      "el-form-item",
                      { staticClass: "auto-width" },
                      [
                        _c(
                          "template",
                          { slot: "label" },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("Message.Notify")))
                            ]),
                            _c("char-count", {
                              staticStyle: {
                                position: "static",
                                display: "block",
                                "font-size": "10px",
                                color: "#909399"
                              },
                              attrs: { form: _vm.form, prefix: "notify" }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-input", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                  expression:
                                    "!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                }
                              ],
                              staticStyle: { flex: "1", width: "120px" },
                              attrs: { disabled: _vm.readonly, no: "21" },
                              model: {
                                value: _vm.form.notifyCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "notifyCode", $$v)
                                },
                                expression: "form.notifyCode"
                              }
                            }),
                            _c("cargo-advance-select", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                  expression:
                                    "synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                }
                              ],
                              staticStyle: { flex: "1", width: "120px" },
                              attrs: {
                                no: "22",
                                disabled: _vm.readonly,
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Company,
                                "method-params": {
                                  partnerManagementMode:
                                    _vm.partnerManagementMode,
                                  branchId: _vm.$store.getters.currentOfficeId,
                                  notify: true
                                },
                                filterable: "",
                                "default-value": _vm.form.notifyId || ""
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.senderAndReceiverChange("notify", p, 7)
                                }
                              }
                            }),
                            _c(
                              "el-button",
                              {
                                staticStyle: { "margin-left": "5px" },
                                attrs: {
                                  no: "23",
                                  disabled: _vm.readonly,
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.clearSenderAndReceiver(
                                      "notify",
                                      7
                                    )
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Reset")))]
                            ),
                            _c(
                              "el-button",
                              {
                                staticStyle: { "margin-left": "5px" },
                                attrs: {
                                  no: "24",
                                  disabled: _vm.readonly,
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.pm.onCopyConsignee()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.CopyTheConsignee"))
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      2
                    ),
                    _vm._l(7, function(count) {
                      return _c(
                        "el-form-item",
                        {
                          key: "notifyLine" + count,
                          staticClass: "auto-width",
                          class: _vm.getSenderAndReceiverColor(
                            "notifyLine",
                            count
                          )
                        },
                        [
                          _c("cargo-input", {
                            ref: "notifyLine" + count,
                            refInFor: true,
                            attrs: {
                              disabled: _vm.readonly,
                              no: "notifyLine" + count,
                              "auto-uppercase":
                                _vm.notUppercaseShipperConsigneNotify,
                              "use-read-only": true
                            },
                            on: {
                              change: function() {
                                return _vm.wrapAddr(
                                  _vm.form,
                                  "notifyLine" + count,
                                  count + 1 > 7
                                    ? null
                                    : "notifyLine" + (count + 1),
                                  _vm.maxChars
                                )
                              }
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                return _vm.showSenderAndReceiverDialog(
                                  "notify",
                                  7,
                                  _vm.isCarrierUserMSC,
                                  _vm.notUppercaseShipperConsigneNotify
                                )
                              }
                            },
                            model: {
                              value: _vm.form["notifyLine" + count],
                              callback: function($$v) {
                                _vm.$set(_vm.form, "notifyLine" + count, $$v)
                              },
                              expression: "form['notifyLine'+count]"
                            }
                          })
                        ],
                        1
                      )
                    }),
                    _c("el-form-item", [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "130px" },
                              attrs: { disabled: _vm.readonly, no: "25" },
                              on: {
                                change: function(val) {
                                  _vm.pm.otherInfoChangeHandler(val)
                                }
                              },
                              model: {
                                value: _vm.otherField,
                                callback: function($$v) {
                                  _vm.otherField = $$v
                                },
                                expression: "otherField"
                              }
                            },
                            _vm._l(_vm.otherFieldsData, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.englishName,
                                  value: item.code
                                }
                              })
                            }),
                            1
                          ),
                          _vm.otherField !== "ALSO NOTIFY"
                            ? _c("cargo-input", {
                                staticStyle: {
                                  "margin-left": "5px",
                                  width: "170px"
                                },
                                attrs: {
                                  no: "26",
                                  disabled: _vm.readonly,
                                  maxlength: _vm.maxChars,
                                  "auto-uppercase":
                                    _vm.notUppercaseShipperConsigneNotify
                                },
                                model: {
                                  value: _vm.otherCode,
                                  callback: function($$v) {
                                    _vm.otherCode = $$v
                                  },
                                  expression: "otherCode"
                                }
                              })
                            : _vm._e(),
                          _vm.otherField === "ALSO NOTIFY"
                            ? _c("cargo-advance-select", {
                                staticStyle: {
                                  flex: "1",
                                  "margin-left": "5px"
                                },
                                attrs: {
                                  no: "79",
                                  disabled: _vm.readonly,
                                  "allow-create": true,
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  "method-params": {
                                    notify: true,
                                    active: true
                                  },
                                  "tag-name": "englishName",
                                  "tag-value": "englishName",
                                  filterable: "",
                                  "default-value": _vm.otherCode || ""
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.pm.alsoNotifyAutoCompleteChange(p)
                                  }
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ]),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.otherField === "ALSO NOTIFY",
                            expression: "otherField==='ALSO NOTIFY'"
                          }
                        ]
                      },
                      [
                        _c("cargo-rich-textarea", {
                          staticStyle: {
                            height: "110px",
                            "margin-left": "70px"
                          },
                          attrs: {
                            no: "27",
                            disabled: !_vm.isEdit,
                            "text-chars": _vm.maxChars,
                            "warning-count": _vm.warningCount
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              return _vm.showAdvanceTextDialog(
                                "ALSO NOTIFY",
                                _vm.form.alsoNotify,
                                function(val) {
                                  _vm.form.alsoNotify = val
                                },
                                false,
                                null,
                                _vm.notUppercaseShipperConsigneNotify,
                                {
                                  warningCount: 45,
                                  maxChar: 0
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.form.alsoNotify,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "alsoNotify", $$v)
                            },
                            expression: "form.alsoNotify"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.otherField === "DGCONSIGN",
                            expression: "otherField==='DGCONSIGN'"
                          }
                        ]
                      },
                      _vm._l(7, function(count) {
                        return _c(
                          "el-form-item",
                          {
                            key: "dgconsignLine" + count,
                            staticClass: "auto-width"
                          },
                          [
                            _c("cargo-input", {
                              ref: "dgconsignLine" + count,
                              refInFor: true,
                              attrs: {
                                disabled: _vm.readonly,
                                no: "dgconsignLine" + count,
                                "auto-uppercase":
                                  _vm.notUppercaseShipperConsigneNotify,
                                "use-read-only": true
                              },
                              on: {
                                change: function() {
                                  return _vm.wrapAddr(
                                    _vm.form,
                                    "dgconsignLine" + count,
                                    count + 1 > 7
                                      ? null
                                      : "dgconsignLine" + (count + 1),
                                    _vm.maxChars
                                  )
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showSenderAndReceiverDialog(
                                    "dgconsign",
                                    7,
                                    _vm.isCarrierUserMSC,
                                    _vm.notUppercaseShipperConsigneNotify
                                  )
                                }
                              },
                              model: {
                                value: _vm.form["dgconsignLine" + count],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "dgconsignLine" + count,
                                    $$v
                                  )
                                },
                                expression: "form['dgconsignLine'+count]"
                              }
                            })
                          ],
                          1
                        )
                      }),
                      1
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.otherField === "ELSEINVOICE",
                            expression: "otherField==='ELSEINVOICE'"
                          }
                        ]
                      },
                      _vm._l(7, function(count) {
                        return _c(
                          "el-form-item",
                          {
                            key: "elseInvoiceLine" + count,
                            staticClass: "auto-width"
                          },
                          [
                            _c("cargo-input", {
                              ref: "elseInvoiceLine" + count,
                              refInFor: true,
                              attrs: {
                                disabled: _vm.readonly,
                                no: "elseInvoiceLine" + count,
                                "auto-uppercase":
                                  _vm.notUppercaseShipperConsigneNotify,
                                "use-read-only": true
                              },
                              on: {
                                change: function() {
                                  return _vm.wrapAddr(
                                    _vm.form,
                                    "elseInvoiceLine" + count,
                                    count + 1 > 7
                                      ? null
                                      : "elseInvoiceLine" + (count + 1),
                                    _vm.maxChars
                                  )
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showSenderAndReceiverDialog(
                                    "elseInvoice",
                                    7,
                                    true,
                                    _vm.notUppercaseShipperConsigneNotify
                                  )
                                }
                              },
                              model: {
                                value: _vm.form["elseInvoiceLine" + count],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "elseInvoiceLine" + count,
                                    $$v
                                  )
                                },
                                expression: "form['elseInvoiceLine'+count]"
                              }
                            })
                          ],
                          1
                        )
                      }),
                      1
                    )
                  ],
                  2
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "down-two section form-column" },
              [
                _c(
                  "el-form",
                  {
                    staticStyle: { height: "100%" },
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": _vm.isZh ? "85px" : "160px",
                      "label-position": "right"
                    }
                  },
                  [
                    _c("span", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.$t("SeaExport.CargoInfo")))
                    ]),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.NumberOfPackagesOnBl")
                        }
                      },
                      [
                        _c("auto-number-input", {
                          attrs: {
                            no: "28",
                            precision: 0,
                            min: 0,
                            disabled: _vm.isCrossTenantSEToSI
                          },
                          on: {
                            change: function($event) {
                              return _vm.pm.quantityChange()
                            }
                          },
                          model: {
                            value: _vm.form.quantity,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "quantity", $$v)
                            },
                            expression: "form.quantity"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.variableCss.packing,
                        attrs: { label: _vm.$t("SeaExport.Package") }
                      },
                      [
                        _c("cargo-packing-select", {
                          attrs: {
                            no: "29",
                            disabled: _vm.isCrossTenantSEToSI,
                            "default-value": _vm.form.packing
                          },
                          on: {
                            change: function(p) {
                              _vm.pm.packingChange(p)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.variableCss.insideQuantity,
                        attrs: { label: _vm.$t("SeaExport.Pieces2") }
                      },
                      [
                        _c("auto-number-input", {
                          attrs: {
                            no: "30",
                            precision: 0,
                            min: 0,
                            disabled: _vm.isCrossTenantSEToSI
                          },
                          model: {
                            value: _vm.form.insideQuantity,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "insideQuantity", $$v)
                            },
                            expression: "form.insideQuantity"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.variableCss.insidePacking,
                        attrs: { label: _vm.$t("SeaExport.PiecesType2") }
                      },
                      [
                        _c("cargo-packing-select", {
                          attrs: {
                            no: "31",
                            "default-value": _vm.form.insidePacking,
                            disabled: _vm.isCrossTenantSEToSI
                          },
                          on: {
                            change: function(p) {
                              _vm.form.insidePacking = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: "custom " + _vm.variableCss.weight,
                        attrs: { label: _vm.$t("SeaExport.GrossWeight") }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "form-item-input",
                            class: _vm.readonly ? "input-disabled" : ""
                          },
                          [
                            _c("auto-number-input", {
                              attrs: {
                                no: "32",
                                precision: 3,
                                min: 0,
                                disabled: _vm.isCrossTenantSEToSI
                              },
                              on: {
                                change: function($event) {
                                  return _vm.pm.weightChange()
                                }
                              },
                              model: {
                                value: _vm.form.weight,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "weight", $$v)
                                },
                                expression: "form.weight"
                              }
                            }),
                            _c("span", [_vm._v("KGS")])
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: "custom " + _vm.variableCss.cubage,
                        attrs: { label: _vm.$t("SeaExport.Cubage") }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "form-item-input",
                            class: _vm.readonly ? "input-disabled" : ""
                          },
                          [
                            _c("auto-number-input", {
                              attrs: {
                                no: "33",
                                precision: 3,
                                min: 0,
                                disabled: _vm.isCrossTenantSEToSI
                              },
                              on: {
                                change: function($event) {
                                  return _vm.pm.cubageChange()
                                }
                              },
                              model: {
                                value: _vm.form.cubage,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "cubage", $$v)
                                },
                                expression: "form.cubage"
                              }
                            }),
                            _c("span", [_vm._v("CBM")])
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: { label: _vm.$t("SeaExport.ChargedWeightRT") }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "form-item-input",
                            class: _vm.readonly ? "input-disabled" : ""
                          },
                          [
                            _c("auto-number-input", {
                              attrs: {
                                no: "34",
                                precision: 3,
                                min: 0,
                                disabled: _vm.isCrossTenantSEToSI
                              },
                              on: {
                                change: function($event) {
                                  return _vm.pm.txtChargeWeightHandler()
                                }
                              },
                              model: {
                                value: _vm.form.chargeWeight,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "chargeWeight", $$v)
                                },
                                expression: "form.chargeWeight"
                              }
                            }),
                            _c("span", [_vm._v("M/T")])
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { staticClass: "custom" },
                      [
                        _c(
                          "el-button",
                          {
                            staticStyle: {
                              float: "right",
                              "margin-left": "5px"
                            },
                            attrs: { no: "35", type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.pm.getHBLInfo("EName")
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "SeaExport.CopyEnglishDescriptionOfGoodsFromHBL"
                                )
                              )
                            )
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.masterFlag,
                                expression: "masterFlag"
                              }
                            ],
                            staticStyle: { float: "right" },
                            attrs: { no: "36", type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.pm.getSlavesHBLEnglishName()
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "SeaExport.CopyEnglishDescriptionOfGoodsFromReceipt"
                                )
                              )
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class:
                          "label-none custom " +
                          _vm.variableCss.cargoEnglishName,
                        attrs: {
                          label: _vm.$t("queryJob.englishDescriptionOfGoods")
                        }
                      },
                      [
                        _c("cargo-rich-textarea", {
                          staticStyle: { height: "110px" },
                          attrs: {
                            no: "37",
                            "show-count": true,
                            "text-chars": _vm.englishNameMaxChars,
                            "warning-count": _vm.englishNameWarningCount,
                            "auto-uppercase": _vm.isUppercaseByConfig,
                            disabled:
                              !_vm.isEdit ||
                              _vm.textareaDisabled ||
                              _vm.isCrossTenantSEToSI
                          },
                          on: {
                            change: function($event) {
                              return _vm.pm.txtCargoEnglishNameChangeHandler()
                            }
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("queryJob.englishDescriptionOfGoods"),
                                _vm.form.cargoEnglishName,
                                function(val) {
                                  _vm.form.cargoEnglishName = val
                                },
                                false,
                                null,
                                _vm.isUppercaseByConfig,
                                {
                                  warningCount: _vm.englishNameWarningCount,
                                  maxChar: _vm.englishNameMaxChars
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.form.cargoEnglishName,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "cargoEnglishName", $$v)
                            },
                            expression: "form.cargoEnglishName"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { staticClass: "custom" },
                      [
                        _c(
                          "el-button",
                          {
                            staticStyle: {
                              float: "right",
                              "margin-left": "5px"
                            },
                            attrs: { no: "38", type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.pm.getHBLInfo("mark")
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.CopyMarksFromHbl")))]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.masterFlag,
                                expression: "masterFlag"
                              }
                            ],
                            staticStyle: { float: "right" },
                            attrs: { type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.pm.getSlavesHBLMark()
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.CopyMarksFromReceipt"))
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: "label-none custom " + _vm.variableCss.mark,
                        attrs: { label: _vm.$t("SeaExport.Marks") }
                      },
                      [
                        _c("cargo-rich-textarea", {
                          staticStyle: { height: "110px" },
                          attrs: {
                            no: "39",
                            "show-count": true,
                            "text-chars": _vm.markMaxChars,
                            "warning-count": _vm.markWarningCount,
                            disabled:
                              !_vm.isEdit ||
                              _vm.textareaDisabled ||
                              _vm.isCrossTenantSEToSI,
                            "auto-uppercase": _vm.isUppercaseByConfig
                          },
                          on: {
                            change: function($event) {
                              return _vm.pm.txtMarkChangeHandler($event)
                            }
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.Marks"),
                                _vm.form.mark,
                                function(val) {
                                  _vm.form.mark = val
                                },
                                false,
                                null,
                                _vm.isUppercaseByConfig,
                                {
                                  warningCount: _vm.markWarningCount,
                                  maxChar: _vm.markMaxChars
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.form.mark,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "mark", $$v)
                            },
                            expression: "form.mark"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "label-none custom",
                        attrs: {
                          label: _vm.$t(
                            "SeaExport.CapitalizedNumbersOfPackages"
                          )
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "40", disabled: true },
                          model: {
                            value: _vm.form.quantitySum,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "quantitySum", $$v)
                            },
                            expression: "form.quantitySum"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "down-three section form-column" },
              [
                _c(
                  "el-form",
                  {
                    staticStyle: { height: "100%" },
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": _vm.isZh ? "96px" : "110px",
                      "label-position": "right"
                    }
                  },
                  [
                    _c("span", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.$t("SeaExport.TransportInfo")))
                    ]),
                    _c("el-form-item", { attrs: { label: "MB/L NO." } }, [
                      _c("div", { staticStyle: { display: "flex" } }, [
                        _c(
                          "div",
                          { staticStyle: { width: "80%" } },
                          [
                            _c("el-input", {
                              attrs: {
                                no: "41",
                                disabled: _vm.isCrossTenantSEToSI
                              },
                              model: {
                                value: _vm.job.mbl,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "mbl", $$v)
                                },
                                expression: "job.mbl"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]),
                    _c(
                      "el-form-item",
                      { attrs: { label: "SO NO." } },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "42",
                            disabled: true,
                            value: _vm.job.soNo
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.MBLBillOfLadingNum") }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "43" },
                          model: {
                            value: _vm.form.serialNo,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "serialNo", $$v)
                            },
                            expression: "form.serialNo"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Payment.vesselAndVoyage") } },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "44",
                            disabled: true,
                            value: _vm.txtFirstVesselVoyage
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("queryJob.dateOfDeparture") } },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "45",
                            value: _vm.job.etd
                              ? _vm.moment(_vm.job.etd).format("YYYY-MM-DD")
                              : null,
                            disabled: true
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.variableCss.dispatchingPlace,
                        attrs: {
                          label: _vm.$t("SeaExport.DocDispatchingPlace")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "46",
                            disabled: _vm.isCrossTenantSEToSI
                          },
                          model: {
                            value: _vm.form.dispatchingPlace,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "dispatchingPlace", $$v)
                            },
                            expression: "form.dispatchingPlace"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.variableCss.loadingPort,
                        attrs: { label: _vm.$t("SeaExport.PortOfLoadingOnBl") }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "47",
                            disabled: _vm.isCrossTenantSEToSI
                          },
                          model: {
                            value: _vm.form.loadingPort,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "loadingPort", $$v)
                            },
                            expression: "form.loadingPort"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.variableCss.dischargingPort,
                        attrs: {
                          label: _vm.$t("SeaExport.PortOfDischargeOnBl")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "48",
                            disabled: _vm.isCrossTenantSEToSI
                          },
                          model: {
                            value: _vm.form.dischargingPort,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "dischargingPort", $$v)
                            },
                            expression: "form.dischargingPort"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.variableCss.destinationPort,
                        attrs: {
                          label: _vm.$t("SeaExport.PlaceOfDeliveryOnBl")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "49",
                            disabled: _vm.isCrossTenantSEToSI
                          },
                          model: {
                            value: _vm.form.destinationPort,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "destinationPort", $$v)
                            },
                            expression: "form.destinationPort"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.MethodOfMblPayment") }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "50",
                            value: _vm.ColumnUtils.paymentTermLabelFunc(
                              _vm.job.paymentTermMBL
                            ),
                            disabled: _vm.isCrossTenantSEToSI
                          },
                          on: {
                            input: function(val) {
                              _vm.job.paymentTermMBL = val
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.PlaceOfMblPayment2") }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "51",
                            disabled: true,
                            value: _vm.form.paymentPlaceBL
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.TransportationClause")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "52",
                            disabled: true,
                            value: _vm.job.freightTermMBL
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.variableCss.blNumber,
                        attrs: { label: _vm.$t("SeaExport.NoOfOriginalBls") }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "53",
                            disabled: _vm.isCrossTenantSEToSI
                          },
                          model: {
                            value: _vm.form.blNumber,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "blNumber", $$v)
                            },
                            expression: "form.blNumber"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.PlaceOfIssue") } },
                      [
                        _c("el-input", {
                          attrs: { no: "54" },
                          model: {
                            value: _vm.form.signPlaceBL,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "signPlaceBL", $$v)
                            },
                            expression: "form.signPlaceBL"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.DateOfIssue") } },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            no: "55",
                            type: "date",
                            "value-format": "yyyy-MM-dd"
                          },
                          model: {
                            value: _vm.form.signDateBL,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "signDateBL", $$v)
                            },
                            expression: "form.signDateBL"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.variableCss.remarks,
                        attrs: { label: _vm.$t("SeaExport.BlRemarks") }
                      },
                      [
                        _c("cargo-rich-textarea", {
                          staticStyle: { height: "110px" },
                          attrs: {
                            no: "56",
                            "text-chars": 0,
                            "warning-count": -1,
                            disabled: _vm.readonly
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.BlRemarks"),
                                _vm.form.remarks,
                                function(val) {
                                  _vm.form.remarks = val
                                },
                                false,
                                null,
                                false,
                                {
                                  warningCount: -1,
                                  maxChar: 0,
                                  autoUppercase: false,
                                  autoHalfWord: false
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.form.remarks,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "remarks", $$v)
                            },
                            expression: "form.remarks"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "down-four section form-column" },
              [
                _c(
                  "el-form",
                  {
                    staticStyle: { height: "100%" },
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": _vm.isZh ? "100px" : "160px",
                      "label-position": "right"
                    }
                  },
                  [
                    _c("span", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.$t("SeaExport.OtherInfo")))
                    ]),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.BlType") } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              no: "57",
                              disabled: _vm.isCrossTenantSEToSI
                            },
                            on: {
                              change: function(val) {
                                _vm.pm.cmbreleaseTypeMBLChangeHandler(val)
                              }
                            },
                            model: {
                              value: _vm.form.releaseType,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "releaseType", $$v)
                              },
                              expression: "form.releaseType"
                            }
                          },
                          _vm._l(_vm.blModeList, function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: item.name,
                                value: item.serialNumber || ""
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.BlProperty") } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              no: "58",
                              value: _vm.job.typeMBL || 1,
                              disabled:
                                _vm.cmbtypeMBLDisabled ||
                                _vm.isCrossTenantSEToSI
                            },
                            on: {
                              change: function(val) {
                                _vm.typeMblHandle(val)
                              }
                            }
                          },
                          _vm._l(_vm.BILL_TYPES, function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: _vm.isZh
                                  ? item.chineseName
                                  : item.englishName,
                                value: item.code
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.job.jointMasterMBLUuid,
                            expression: "job.jointMasterMBLUuid"
                          }
                        ],
                        attrs: { label: _vm.$t("SeaExport.MBLHBR") }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "59",
                            value: _vm.job.jointMasterMBL
                              ? _vm.job.jointMasterMBL.jobNo
                              : ""
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "red",
                        attrs: { label: _vm.$t("SeaExport.ReleasingStatus") }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "62",
                            disabled: true,
                            value: _vm.lblReleaseState
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.preverifyDate") } },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            no: "63",
                            disabled: true,
                            type: "date",
                            "value-format": "yyyy-MM-dd"
                          },
                          model: {
                            value: _vm.form.reviewDate,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "reviewDate", $$v)
                            },
                            expression: "form.reviewDate"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.DateOfCargoDetention")
                        }
                      },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            no: "64",
                            disabled: true,
                            type: "date",
                            "value-format": "yyyy-MM-dd"
                          },
                          model: {
                            value: _vm.form.withholdDate,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "withholdDate", $$v)
                            },
                            expression: "form.withholdDate"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.BlReleasingNo") } },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "65",
                            disabled: true,
                            value: _vm.form.surrenderedNo
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.ReleasingDate") } },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            no: "66",
                            disabled: true,
                            type: "date",
                            "value-format": "yyyy-MM-dd"
                          },
                          model: {
                            value: _vm.form.releaseDate,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "releaseDate", $$v)
                            },
                            expression: "form.releaseDate"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.ParamRemark") } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { no: "67" },
                            model: {
                              value: _vm.form.printParam4,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "printParam4", $$v)
                              },
                              expression: "form.printParam4"
                            }
                          },
                          _vm._l(_vm.pm.printParam4Type, function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: { label: item.label, value: item.data }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.ShippingCompanySCAC")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "68",
                            disabled: true,
                            value: _vm.job.carrierScac || _vm.txtCarrierScAc
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.OverseasAgentSCAC") }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "69",
                            disabled: true,
                            value: _vm.txtBookingAgentScAc
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.ManifestDescriptionOfGoods")
                        }
                      },
                      [
                        _c("cargo-rich-textarea", {
                          staticStyle: { height: "110px" },
                          attrs: {
                            no: "70",
                            disabled: !_vm.isEdit,
                            "text-chars": 0,
                            "warning-count": -1
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.ManifestDescriptionOfGoods"),
                                _vm.form.cargoManifestName,
                                function(val) {
                                  _vm.form.cargoManifestName = val
                                },
                                false,
                                null,
                                false,
                                {
                                  warningCount: -1,
                                  maxChar: 0,
                                  autoUppercase: false,
                                  autoHalfWord: false
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.form.cargoManifestName,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "cargoManifestName", $$v)
                            },
                            expression: "form.cargoManifestName"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.ReasonOfCargoDetention")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "71",
                            disabled: true,
                            value: _vm.form.withholdReason,
                            type: "textarea",
                            rows: 5
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.advanceTextDialog.visible,
                title: _vm.advanceTextDialog.title,
                width: "600px",
                "close-on-click-modal": false,
                "close-on-press-escape": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.advanceTextDialog, "visible", $event)
                }
              }
            },
            [
              _c("cargo-rich-textarea", {
                staticStyle: { height: "320px" },
                attrs: {
                  "text-chars": _vm.advanceTextDialog.formatObj.maxChar,
                  "auto-uppercase": _vm.advanceTextDialog.isUppercase,
                  "warning-count": _vm.advanceTextDialog.formatObj.warningCount,
                  disabled: !_vm.isEdit
                },
                model: {
                  value: _vm.advanceTextDialog.value,
                  callback: function($$v) {
                    _vm.$set(_vm.advanceTextDialog, "value", $$v)
                  },
                  expression: "advanceTextDialog.value"
                }
              }),
              _c(
                "el-form",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.advanceTextDialog.showContact,
                      expression: "advanceTextDialog.showContact"
                    }
                  ],
                  staticStyle: { "padding-top": "5px" },
                  attrs: {
                    inline: true,
                    disabled: !_vm.isEdit,
                    "label-width": "50px",
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("Payment.contactPerson") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "110px" },
                        attrs: { no: "72" },
                        model: {
                          value: _vm.advanceTextDialog.extendData.contact,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.advanceTextDialog.extendData,
                              "contact",
                              $$v
                            )
                          },
                          expression: "advanceTextDialog.extendData.contact"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.Tel") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "110px" },
                        attrs: { no: "73" },
                        model: {
                          value: _vm.advanceTextDialog.extendData.mobile,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.advanceTextDialog.extendData,
                              "mobile",
                              $$v
                            )
                          },
                          expression: "advanceTextDialog.extendData.mobile"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.Fax") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "110px" },
                        attrs: { no: "74" },
                        model: {
                          value: _vm.advanceTextDialog.extendData.fax,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.advanceTextDialog.extendData,
                              "fax",
                              $$v
                            )
                          },
                          expression: "advanceTextDialog.extendData.fax"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.advanceTextDialog.showContact,
                      expression: "advanceTextDialog.showContact"
                    }
                  ],
                  attrs: {
                    inline: true,
                    disabled: !_vm.isEdit,
                    "label-width": "50px",
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.Email2") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "110px" },
                        attrs: { no: "75" },
                        model: {
                          value: _vm.advanceTextDialog.extendData.email,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.advanceTextDialog.extendData,
                              "email",
                              $$v
                            )
                          },
                          expression: "advanceTextDialog.extendData.email"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.ZIP") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "110px" },
                        attrs: { no: "76" },
                        model: {
                          value: _vm.advanceTextDialog.extendData.zipCode,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.advanceTextDialog.extendData,
                              "zipCode",
                              $$v
                            )
                          },
                          expression: "advanceTextDialog.extendData.zipCode"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.City") }
                    },
                    [
                      _c("cargo-location-select", {
                        staticStyle: { width: "110px" },
                        attrs: {
                          "default-value": _vm.advanceTextDialog.extendData.city
                        },
                        on: {
                          change: function(p) {
                            _vm.advanceTextDialog.extendData.city = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "span",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isEdit,
                          expression: "isEdit"
                        }
                      ],
                      attrs: { no: "77", type: "primary" },
                      on: { click: _vm.finishAdvanceText }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "78" },
                      on: {
                        click: function($event) {
                          _vm.advanceTextDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("bill-address-dialog", {
            attrs: {
              visible: _vm.billAddressDialog.visible,
              job: _vm.billAddressDialog.job,
              params: _vm.billAddressDialog.params
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.billAddressDialog, "visible", $event)
              },
              callback: _vm.codeSearchCallback
            }
          }),
          _c("search-bill-no-dialog", {
            attrs: {
              visible: _vm.searchBillNoDialog.visible,
              params: _vm.searchBillNoDialog.params,
              lob: _vm.job.lob
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.searchBillNoDialog, "visible", $event)
              },
              selected: function(p) {
                _vm.pm.selectionItemHandler(p)
              }
            }
          }),
          _c("receipt-history-dialog", {
            attrs: {
              visible: _vm.receiptHistoryDialog.visible,
              "job-uuid": _vm.job.uuid || ""
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.receiptHistoryDialog, "visible", $event)
              }
            }
          }),
          _c("status-change-history-dialog", {
            attrs: {
              visible: _vm.statusChangeHistoryDialog.visible,
              "business-data-id": _vm.form.uuid
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(
                  _vm.statusChangeHistoryDialog,
                  "visible",
                  $event
                )
              }
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }